import Vue from 'vue';
import Component from 'vue-class-component';

// tslint:disable-next-line:no-var-requires
const numeral = require('numeral');

@Component({
  filters: {
    insertComma(charge: number): string {
      return numeral(charge).format('0,0');
    },
  },
})
export default class Formatter extends Vue {
  public convertToValidValue(val: string): string {
    let num = 0;
    // 全角数字を半角に変換
    let str = val.match(/^[０-９]+$/) ? this.convertToHalf(val) : val;
    // 4桁以上の場合カット
    str = str.length > 3 ? str.slice(0, 3) : str;

    // Numberに変更できない場合 0にする
    num = parseInt(str);
    num = isNaN(num) ? 0 : num;
    // 負の数は入力できない
    num = num < 0 ? 0 : num;
    return String(num);
  }

  private convertToHalf(val: string) {
    return val.replace(/[０-９]/g, (s: string) => {
      return String.fromCharCode(s.charCodeAt(0) - 65248);
    });
  }
}
